import { get, writable } from "svelte/store";

import SimpleESRIPointLayer from "./Map/SimpleESRIPointLayer";

const AppStore = {
	menu: {
		tab: writable(""),
		visible: writable(false),
		maritime: {
			tab: writable("")
		},
		aviation: {
			tab: writable("")
		},
		environment: {
			tab: writable("")
		}
	},
	cms: {
		visible: writable(false)
	},
	hazards: {
		volcanoes: new SimpleESRIPointLayer("Volcanoes"),
		earthquakes: new SimpleESRIPointLayer("Earthquakes"),
		floods: new SimpleESRIPointLayer("Floods")
	},
	portAssessments: new SimpleESRIPointLayer("Port Assessments"),
	miss: new SimpleESRIPointLayer("MISS"),
	ttws: {
		visible: writable(false)
	},
	previewingVesselCommentAttachments: writable([]), // ^AG: Have no idea where to put this at the moment. Could be CommentsStore, but that depends on the context (CMS or info card)
	snackbar: null,
	helpers: {
		isMenuVisible: () => {
			return get(AppStore.menu.visible);
		},
		getMenuOffset: () => {
			let offset = 0;
			// TODO: This should take into account dynamic sizing of the menus.
			if (AppStore.helpers.isMenuVisible()) {
				offset += 350;
			}
			return offset;
		}
	},
	actions: {
		addAttachmentPreview: (attachment) => {
			const currentAttachments = get(AppStore.previewingVesselCommentAttachments);
			if (currentAttachments.indexOf(attachment) === -1) {
				currentAttachments.push(attachment);
				AppStore.previewingVesselCommentAttachments.set(currentAttachments);
			}
		},
		addImagePreview: (url, filename = "Image") => {
			const data = {
				id: 0,
				fileName: filename,
				url: url,
				userId: 1,
				fileType: "png",
				materialIcon: "image"
			};
			AppStore.actions.addAttachmentPreview(data);
		},
		toggleMenu: () => {
			AppStore.menu.visible.update((value) => {
				return !value;
			});
		},
		setMenuVisible: (b) => {
			AppStore.menu.visible.set(b);
		}
	}
};
export default AppStore;
